/**
 * 班级卡片
 */
export default {
  groupBuy: 'Remise de groupe',
}
